export const getFormFields = (options, updatedAt) => [
    {
        name: "Template Link",
        prompt: "Enter Template Link",
        title: "detail_link",
        required: true,
        type: "list",
        isDropdown: true,
        helpIcon: true,
        options: options,
        lastRefreshedAt: updatedAt ? new Date(updatedAt).toLocaleString() : "-1"
    },
    {
        name: "Name",
        prompt: "Enter Name",
        title: "name",
        required: true,
        type: "text",
        isDropdown: false,
        helpIcon: false,
        limit: 100
    },
    {
        name: "Description",
        prompt: "Enter Description",
        title: "description",
        required: true,
        type: "text",
        isDropdown: false,
        helpIcon: false,
        limit: 250
    },
    {
        name: "Documentation",
        prompt: "Enter Documentation Label",
        title: "documentation_label",
        required: false,
        isDropdown: false,
        helpIcon: false,
        type: "grouped",
        parent: "Documentation",
        limit: 100
    },
    {
        name: "",
        prompt: "Enter Documentation Link",
        title: "documentation_link",
        required: false,
        isDropdown: false,
        helpIcon: false,
        type: "grouped",
        parent: "Documentation",
        limit: 100
    },
    {
        name: "Version",
        prompt: "Enter Version",
        type: "text",
        title: "version",
        required: false,
        isDropdown: false,
        helpIcon: false,
        limit: 100
    },
];
